/* OVESSACO theme — vanilla JS, no dependencies */
(() => {
  const routes = window.theme?.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(() => d.classList.add('is-open'));
    document.body.classList.add('no-scroll');
    d.setAttribute('aria-hidden', 'false');
    const f = d.querySelector('[data-drawer-close], a, button, input');
    f && f.focus();
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    setTimeout(() => { d.hidden = true; }, 300);
    lastFocus && lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      if (opener.dataset.drawerOpen === 'cart-drawer' && window.theme?.cartType !== 'drawer') return;
      e.preventDefault();
      openDrawer(opener.dataset.drawerOpen);
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Cart ---------- */
  const CART_SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  async function renderCartSections(sections) {
    if (!sections) return;
    for (const id of CART_SECTIONS) {
      if (!sections[id]) continue;
      const html = new DOMParser().parseFromString(sections[id], 'text/html');
      const fresh = html.querySelector(`[data-section-target="${id}"]`);
      const current = document.querySelector(`[data-section-target="${id}"]`);
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }
  }
  async function cartRequest(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: CART_SECTIONS, sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Cart error');
    return data;
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || window.theme?.cartType !== 'drawer') return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const err = form.querySelector('[data-form-error]');
    const fd = new FormData(form);
    btn && btn.setAttribute('aria-busy', 'true');
    try {
      const data = await cartRequest(routes.cart_add_url + '.js', {
        items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }]
      });
      await renderCartSections(data.sections);
      if (err) err.hidden = true;
      openDrawer('cart-drawer');
    } catch (ex) {
      if (err) { err.textContent = ex.message; err.hidden = false; } else { form.submit(); }
    } finally {
      btn && btn.removeAttribute('aria-busy');
    }
  });

  async function changeLine(line, quantity) {
    const wrap = document.querySelector('[data-section-target="cart-drawer"]');
    wrap && wrap.setAttribute('aria-busy', 'true');
    try {
      const data = await cartRequest(routes.cart_change_url + '.js', { line, quantity });
      if (document.body.dataset.template === 'cart') { window.location.reload(); return; }
      await renderCartSections(data.sections);
    } catch (ex) {
      alert(ex.message);
    } finally {
      wrap && wrap.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    changeLine(Number(b.dataset.line), Number(b.dataset.lineChange));
  });

  /* ---------- Quantity steppers (product form) ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    const v = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.qtyStep));
    input.value = v;
  });

  /* ---------- Tabs ---------- */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[role="tab"]');
    if (!tab) return;
    const list = tab.closest('[role="tablist"]');
    const scope = list.parentElement;
    $$('[role="tab"]', list).forEach((t) => t.setAttribute('aria-selected', t === tab ? 'true' : 'false'));
    $$('[role="tabpanel"]', scope).forEach((p) => { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
  });

  /* ---------- Product gallery ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-thumb]');
    if (!t) return;
    const g = t.closest('[data-gallery]');
    const main = $('[data-gallery-main] img', g);
    main.src = t.dataset.src;
    main.srcset = t.dataset.srcset || '';
    main.alt = t.dataset.alt || '';
    $$('[data-thumb]', g).forEach((x) => x.setAttribute('aria-current', x === t ? 'true' : 'false'));
  });

  /* ---------- Variant picker ---------- */
  $$('[data-variant-picker]').forEach((picker) => {
    const section = picker.closest('[data-product-section]');
    const product = JSON.parse($('[data-product-json]', section).textContent);
    const form = $('form[data-product-form]', section);
    const idInput = $('input[name="id"]', form);
    const btn = $('[type="submit"]', form);
    const fmt = (cents) => {
      const f = window.theme?.moneyFormat || '${{amount}}';
      const amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return f.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    };
    picker.addEventListener('change', () => {
      const selected = $$('fieldset', picker).map((fs) => $('input:checked', fs)?.value);
      const v = product.variants.find((x) => x.options.every((o, i) => o === selected[i]));
      const priceEl = $('[data-price]', section);
      if (!v) {
        btn.disabled = true;
        btn.textContent = window.theme.strings.unavailable;
        return;
      }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
      if (priceEl) {
        const sale = v.compare_at_price && v.compare_at_price > v.price;
        priceEl.className = 'price' + (sale ? ' price--sale' : '');
        priceEl.innerHTML = `<span class="price__current">${fmt(v.price)}</span>` + (sale ? ` <s>${fmt(v.compare_at_price)}</s>` : '');
      }
      const sku = $('[data-sku]', section);
      if (sku) sku.textContent = v.sku || '';
      if (v.featured_media) {
        const thumb = $(`[data-thumb][data-media-id="${v.featured_media.id}"]`, section);
        thumb && thumb.click();
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  /* ---------- Collection sort / filters ---------- */
  document.addEventListener('change', (e) => {
    const f = e.target.closest('form[data-auto-submit]');
    if (f) f.requestSubmit ? f.requestSubmit() : f.submit();
  });
})();
